import { render, staticRenderFns } from "./ApproveModal.vue?vue&type=template&id=a4c8d1ea&lang=pug"
import script from "./ApproveModal.vue?vue&type=script&lang=js"
export * from "./ApproveModal.vue?vue&type=script&lang=js"
import style0 from "./ApproveModal.vue?vue&type=style&index=0&id=a4c8d1ea&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports